import React from 'react';

import theme from 'theme';

import { LitigeGestionEtatEnum } from "types/enums";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';


// Icons
import DateRangeIcon from '@mui/icons-material/DateRange';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DescriptionIcon from '@mui/icons-material/Description';


import { ApiReclamationLitige } from 'types/apiReturns';

import ReclamationLitigePieces from './ReclamationLitigePieces'

import GeswebLink from 'components/Shared/GeswebLink'
import Datetime from 'components/Shared/Datetime'
import Utilisateur from 'components/Shared/Utilisateur'

type Props = {
  litige: ApiReclamationLitige;
};

export default function ReclamationLitige({ litige }: Props) {

  return (
    <>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={1} sx={{ p: 2, height: '100%' }}>

            <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Facture&nbsp;
              <GeswebLink
                cle={litige.facture}
                structure='facture'
                mode='link'
                label={litige.facture}
                environment={null}
              />
            </Typography>

            <Box sx={{ margin: 0, display:'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0px'}}>
            
              {/* Colonne 1 */}
              <Box sx={{ gridColumn: 1, gridRow: 1, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Total HT
              </Box>              
              <Box sx={{ gridColumn: 1, gridRow: 2, paddingLeft: 2}}>
                {litige.montantTotalHT?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 1, gridRow: 3, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Total TVA
              </Box>              
              <Box sx={{ gridColumn: 1, gridRow: 4, paddingLeft: 2}}>
                {litige.montantTotalTVA?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 1, gridRow: 5, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Total TTC
              </Box>              
              <Box sx={{ gridColumn: 1, gridRow: 6, paddingLeft: 2}}>
                {litige.montantTotalTTC?.toFixed(2)}
              </Box>
              
              {/* Colonne 2 */}
              
              <Box sx={{ gridColumn: 2, gridRow: 1, paddingBottom: 1 , color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Montant bloqué HT
              </Box>              
              <Box sx={{ gridColumn: 2, gridRow: 2, paddingBottom: 1, paddingLeft: 2}}>
                {litige.montantBloqueHT?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 2, gridRow: 3, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Montant bloqué TTC
              </Box>              
              <Box sx={{ gridColumn: 2, gridRow: 4, paddingBottom: 1, paddingLeft: 2}}>
                {litige.montantBloqueTTC?.toFixed(2)}
              </Box>
              
              {/* Colonne 3 */}
              <Box sx={{ gridColumn: 3, gridRow: 1, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Frais facturation
              </Box>              
              <Box sx={{ gridColumn: 3, gridRow: 2, paddingBottom: 1, paddingLeft: 2}}>
                {litige.montantFrais?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 3, gridRow: 3, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                ECO Taxe
              </Box>              
              <Box sx={{ gridColumn: 3, gridRow: 4, paddingBottom: 1, paddingLeft: 2}}>
                {litige.montantEcoTaxe?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 3, gridRow: 5, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Escompte
              </Box>              
              <Box sx={{ gridColumn: 3, gridRow: 6, paddingBottom: 1, paddingLeft: 2}}>
                {litige.montantEscompte?.toFixed(2)}
              </Box>
              
              <Box sx={{ gridColumn: 3, gridRow: 7, paddingBottom: 1, color : theme.palette.primary.light, fontWeight: 'bold'}}>
                Ventilation TVA
              </Box>              
              <Box sx={{ gridColumn: 3, gridRow: 8, paddingBottom: 1, paddingLeft: 2}}>

                { litige.tauxTVA_1 !== null && litige.montantTVA_1 !== null && (
                  <Typography>{litige.tauxTVA_1?.toFixed(2)} | {litige.montantTVA_1?.toFixed(2)}</Typography>
                )}

                { litige.tauxTVA_2 !== null && litige.montantTVA_2 !== null && (
                  <Typography>{litige.tauxTVA_2?.toFixed(2)} | {litige.montantTVA_2?.toFixed(2)}</Typography>
                )}
                
              </Box>

            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={1} sx={{ p: 2, height: '100%', position: 'relative' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
              <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold', mb: 0 }}>
                Litige&nbsp;
                <GeswebLink
                  cle={litige.cle}
                  structure='litige'
                  mode='link'
                  label={litige.cle}
                  environment={null}
                />
                <span style={{
                  marginLeft: '8px',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  backgroundColor: litige.etat === LitigeGestionEtatEnum.Ouvert ? '#4caf50' :
                                  litige.etat === LitigeGestionEtatEnum.Clos ? '#f44336' : '#ff9800',
                  color: 'white',
                  fontSize: '0.8rem',
                  fontWeight: 'bold'
                }}>
                  {litige.etat === LitigeGestionEtatEnum.Ouvert ? 'Ouvert' :
                  litige.etat === LitigeGestionEtatEnum.Clos ? 'Clos' : 'En attente de paiement'}
                </span>
              </Typography>

              {litige.responsable && (
                <Box sx={{ flexShrink: 0 }}>
                  <span>En charge : </span>
                  <Utilisateur
                    utilisateur={litige.responsable}
                    format="chip"
                  />
                </Box>
              )}
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" sx={{ color : theme.palette.primary.light, fontWeight: 'bold', mb: 1 }}>
                  Ouverture
                </Typography>
                {litige.dateDebut && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <DateRangeIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                    <Datetime datetime={litige.dateDebut} />
                  </Typography>
                )}
                {litige.libelleOrigine && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <HelpOutlineIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                    {litige.libelleOrigine} {litige.origine && `(${litige.origine})`}
                  </Typography>
                )}
                {litige.commentaire && (
                  <Typography variant="body2" sx={{ mb: 1, whiteSpace: "pre-wrap" }}>
                    <DescriptionIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                    {litige.commentaire}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" sx={{ color : theme.palette.primary.light, fontWeight: 'bold', mb: 1 }}>
                  Clôture
                </Typography>
                {litige.dateCloture && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <DateRangeIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                    <Datetime datetime={litige.dateCloture} />
                  </Typography>
                )}
                {litige.libelleCloture && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {litige.libelleCloture} {litige.cloture && `(${litige.cloture})`}
                  </Typography>
                )}
                {litige.commentaireCloture && (
                  <Typography variant="body2" sx={{ mb: 1, whiteSpace: "pre-wrap" }}>
                    <DescriptionIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                    {litige.commentaireCloture}
                  </Typography>
                )}
              </Grid>
            </Grid>

          </Paper>
        </Grid>
      </Grid>

      <ReclamationLitigePieces pieces={litige.pieces} />

    </>
  );
}